export default "__VITE_ASSET__59de9220__"